import React from 'react'
import './articleCard.scss'

function ArticleCard({ title, text, url, image, onClick }) {
  return (
    <div className="f-article-card" onClick={onClick && onClick}>
      <a href={url} target="_blank" className="f-article-card__image">
        <img src={image} alt="article-image-reference" />
      </a>
      <div className="f-article-card__text">
        <p className="f-article-card__text__title">{title}</p>
        <p className="f-article-card__text__content">{text}</p>
      </div>
    </div>
  )
}

export default ArticleCard
